import { api } from "@signet/web-kit";

/* What the CB Stats page reads from /api/m/cbstats, typed once. Mirrors server/store.ts. */

export const BASE = "/api/m/cbstats";

export type StreamDay = { day: string; minutes: number; start: string; end: string; peak: number; avg: number; followersGained: number };
export type Status = "on" | "behind" | "none";

export type WeekRow = {
  account: string;
  creator: string;
  username: string;
  days: (StreamDay | null)[];
  streams: number;
  qualifying: number;
  minutes: number;
  peak: number | null;
  avg: number | null;
  followersGained: number;
  status: Status;
  trackedFrom: string | null;
  lastWeek: { streams: number; qualifying: number; minutes: number; tracked: boolean };
  live: boolean;
};

export type Week = { week: string; today: string; current: boolean; daysLeft: number; lastSweep: string | null; rows: WeekRow[] };

export type History = {
  account: string;
  creator: string;
  username: string;
  addedAt: string;
  weeks: { week: string; streams: number; qualifying: number; minutes: number; tracked: boolean }[];
  streams: StreamDay[];
};

export type Account = { id: string; creator: string; username: string; addedAt: string; addedBy: string | null; lastLive: string | null };

export const cbKeys = {
  all: ["cbstats"] as const,
  week: (week: string) => ["cbstats", "week", week] as const,
  history: (id: string) => ["cbstats", "history", id] as const,
  accounts: ["cbstats", "accounts"] as const,
  creators: ["cbstats", "creators"] as const,
};

export const fetchWeek = (week?: string) => api<Week>(`${BASE}/week${week ? `?${new URLSearchParams({ week })}` : ""}`);
export const fetchHistory = (id: string) => api<History>(`${BASE}/accounts/${encodeURIComponent(id)}/history`);
export const fetchAccounts = () => api<{ accounts: Account[] }>(`${BASE}/accounts`);
export const fetchCreators = () => api<{ creators: string[] }>(`${BASE}/creators`);
export const addAccount = (input: { creator: string; username: string }) => api<{ account: Account }>(`${BASE}/accounts`, { body: input });
export const removeAccount = (id: string) => api(`${BASE}/accounts/${encodeURIComponent(id)}`, { method: "DELETE" });

export const roomUrl = (username: string) => `https://chaturbate.com/${encodeURIComponent(username)}/`;
export const count = (n: number) => n.toLocaleString("en-AU");
